import { useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 768
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

const _subscribe = (onChange: () => void) => {
  const media = window.matchMedia(QUERY)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}

/** Whether the screen is phone-sized (used by the sidebar to switch to a sheet). */
export const useIsMobile = (): boolean =>
  useSyncExternalStore(
    _subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  )
